import React, { useState, useEffect } from "react";
import { FiSave, FiX } from "react-icons/fi";

const BlogForm = ({ selectedBlog, onSubmit, onCancel, isLoading = false }) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [published, setPublished] = useState(true);

  useEffect(() => {
    if (selectedBlog) {
      setTitle(selectedBlog.title || "");
      setContent(selectedBlog.content || "");
      setPublished(selectedBlog.published ?? true);
    } else {
      setTitle("");
      setContent("");
      setPublished(true);
    }
  }, [selectedBlog]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ title, content, published });
  };

  const handleCancel = () => {
    setTitle("");
    setContent("");
    setPublished(true);
    onCancel();
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-brand-gold">
          {selectedBlog ? "Edit Blog" : "Create New Blog"}
        </h2>
        {selectedBlog && (
          <button
            onClick={handleCancel}
            className="p-2 text-gray-400 hover:text-red-400 transition-colors"
            title="Cancel editing"
          >
            <FiX size={20} />
          </button>
        )}
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="blog-title"
            className="block text-sm font-medium text-gray-300 mb-2"
          >
            Title *
          </label>
          <input
            id="blog-title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-gold focus:border-transparent"
            placeholder="Enter blog title..."
            required
          />
        </div>

        <div>
          <label
            htmlFor="blog-content"
            className="block text-sm font-medium text-gray-300 mb-2"
          >
            Content *
          </label>
          <textarea
            id="blog-content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={6}
            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-transparent resize-vertical"
            placeholder="Write your blog content..."
            required
          />
        </div>

        <div className="flex items-center gap-3">
          <input
            id="blog-published"
            type="checkbox"
            checked={published}
            onChange={(e) => setPublished(e.target.checked)}
            className="w-4 h-4 text-brand-gold bg-gray-700 border-gray-600 rounded focus:ring-brand-gold focus:ring-2"
          />
          <label
            htmlFor="blog-published"
            className="text-sm font-medium text-gray-300"
          >
            Publish immediately
          </label>
        </div>

        <div className="flex gap-3 pt-4">
          <button
            type="submit"
            disabled={isLoading}
            className="flex items-center gap-2 bg-brand-gold hover:bg-brand-gold/90 disabled:bg-gray-600 text-black font-bold px-4 py-2 rounded-md transition-colors font-medium"
          >
            <FiSave size={16} />
            {isLoading
              ? "Saving..."
              : selectedBlog
              ? "Update Blog"
              : "Create Blog"}
          </button>

          {selectedBlog && (
            <button
              type="button"
              onClick={handleCancel}
              className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md transition-colors font-medium"
            >
              <FiX size={16} />
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default BlogForm;
